import * as urlUtil from '../../util/UrlUtil'
import pictlinkApiV2 from '../interceptor/AxiosInterceptorV2';

/**
 * ログイン/会員登録後の遷移先をAPI仕様に合わせた形に組み立てる
 * @param {string} path ログイン/会員登録後後の遷移先パス(/sp/以下)
 */
function buildPostValue(path){
    return `originalUrl=https://${urlUtil.absoluteUrlUtil.buildPictlinkAbsoluteUrl(path)}`
}
/**
 * ログイン後の遷移先を指定するためにcookieにセットする.
 * @param {string} postValue ログイン後の遷移先パス(buildPostValue()でAPI仕様に合わせた形のパス)
 */
function setAfterLoginUrl(postValue) {
    const apiPath = urlUtil.apiEndpointUtil.setAfterLoginUrlApiUrl()
    return pictlinkApiV2.post(apiPath, postValue)
        .then(function (result) {
            return result
        })
}

/**
 * 会員登録後の遷移先を指定するためにcookieにセットする.
 * @param {string} postValue 会員登録後の遷移先パス(buildPostValue()でAPI仕様に合わせた形のパス)
 */
function setAfterRegisterUrl(postValue) {
    const apiPath = urlUtil.apiEndpointUtil.setAfterRegisterUrlApiUrl()
    return pictlinkApiV2.post(apiPath, postValue)
        .then(function (result) {
            return result
        })
}

/**
 * 会員登録後・ログイン後の遷移先を指定するためにcookieにセットする.
 * 会員登録画面にもログインボタン・ログイン画面にも会員登録ボタンがあるため、
 * setAfterLoginUrl・setAfterRegisterUrl単品ではなくこちらの関数を使ってください.
 * @param {string} afterPath 会員登録・ログイン後の遷移先パス(/sp/以下)
 */
export async function setAfterUrl(afterPath) {

    const postValue = buildPostValue(afterPath)
    const promiseSetAfterLoginUrl = setAfterLoginUrl(postValue)
    const promiseSetAfterRegisterUrl = setAfterRegisterUrl(postValue)

    return Promise.all([promiseSetAfterLoginUrl, promiseSetAfterRegisterUrl]).then((values) => {
        return values
    });
}